import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ChatMessage, KanbanColumn } from './tickets.models';

export const TicketsActions = createActionGroup({
  source: 'Tickets',
  events: {
    Load: emptyProps(),
    'Load Started': emptyProps(),
    'Board Loaded': props<{ columns: KanbanColumn[] }>(),
    'Load Failed': props<{ error: string }>(),
    'Set Board Draft': props<{ columns: KanbanColumn[] }>(),
    'Save Board': emptyProps(),
    'Save Board Started': emptyProps(),
    'Save Board Succeeded': props<{ savedAt: number }>(),
    'Save Board Failed': props<{ error: string }>(),
    'Refresh Board': props<{ projectId?: string }>(),
    'Set Execution Model Id': props<{ modelId: string }>(),
    'Set Chat Messages': props<{ messages: ChatMessage[] }>(),
  },
});
